/* eslint-disable react/require-default-props */
import React from 'react';
import {
    withStyles, makeStyles, createStyles, Theme,
} from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: 'calc(100% - 30px)',
    },
    label: {
        color: 'rgba(0,0,0,0.84)',
        fontSize: 12,
    },
    ofText: {
        margin: '0px 5px',
    },
}));

const styles = {
    root: {
        color: '#ccc',
        height: 3,
    },
    thumb: {
        height: 16,
        width: 16,
        backgroundColor: '#2099c5',
        border: '2px solid #FFFFFF',
        marginTop: -8,
        marginLeft: -12,
        '&:focus': {
            boxShadow: '0 0 0 2px #007fad',
            backgroundColor: '#007fad',
            outline: '0 !important',
        },
        '&:hover, &$active': {
            boxShadow: 'none !important',
            backgroundColor: '#007fad',
        },
    },
    active: {},
    rail: {
        height: 4,
        top: 11,
        backgroundColor: '#8490a3',
        borderRadius: 7,
        opacity: 'unset !important',
    },
    track: {
        height: 8,
        top: 9,
        borderRadius: 99,
        color: '#2099c5',
    },
};

const RangeSlider = withStyles(styles)(Slider);
type ScaleRangeProps = {
    value: number,
    min: number,
    max: number,
    handleChange?: (e: React.ChangeEvent, val: number) => void,
    showMinMax?: false,
    metricDataId?: number,
    metricId?: number,
    updateValueDisabled: boolean
}

const ScaleRange = ({
    min,
    max,
    value,
    handleChange,
    showMinMax,
    metricDataId,
    metricId,
    updateValueDisabled
} :ScaleRangeProps) => {
    const classes = useStyles();
    const minValue = Number(min);
    const maxValue = Number(max);
    const ofTextValue = showMinMax ? `${minValue} - ${maxValue}` : maxValue;
    const v = ((value === null || value === undefined) ? minValue : Number(value));
    const [newValue, setValue] = React.useState<number>(null);
    const mId = metricId;
    const mdId = metricDataId;

    const handleOnChange = (event: any, newVal: number) => {
        setValue(newVal);
    };

    return (
        <>
            <span className="sr-only">&nbsp;</span>
            <div
                className={`kr-data-scale-range ${classes.root} fieldCompa11y`}
                style={mdId ? { width: '96px', height: '20px', marginTop: '-4px' } : {}}
            >
                <RangeSlider
                    aria-label="range slider"
                    value={newValue || v}
                    min={minValue}
                    max={maxValue}
                    onChange={mdId ? handleOnChange : handleChange}
                    disabled={updateValueDisabled}
                />
                {
                    !mdId && (
                        <div className={`scale-range-labels ${classes.label}`}>
                            <span>{v}</span>
                            <span className={classes.ofText}>of</span>
                            <span>{ofTextValue}</span>
                        </div>
                    )
                }
            </div>
            { mdId && (
                <div className="updateKRSliderData">
                    <div className="displayInlineB updateKrScaleText">
                        <span className="updateKRMinVal">{newValue || v}</span>
                        <span className={classes.ofText}>of</span>
                        <span>{ofTextValue}</span>
                        <input
                            type="hidden"
                            name={`metric[${mId}][${mdId}][val]`}
                            value={newValue || v}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default ScaleRange;
